import { connect } from 'react-redux'
import { cleanupSessionTimeoutEvent } from '../../actions/application'


const mapDispatchToProps = dispatch => {
    return {
        eventCleanup: cleanupSessionTimeoutEvent
    }
}

export default connect(null, mapDispatchToProps)
